import { useEffect } from 'react'

import { FIVE_MINUTES_IN_MS } from '~/constants'
import useGetAgent from '~/features/agents/hooks/useGetAgent'
import { useSetAgentId } from '~/features/agents/hooks/useSetAgentId'
import { EChatStatus } from '~/features/agents/models'
import useGetAuthSessionQuery from '~/features/auth/hooks/useGetAuthSessionQuery'
import { store, sessionStore } from '~/store'

/**
 * Reset agent settings for guest users
 * If a unauthenticated user has an agent, check every 5 minutes if the chatStatus === active
 * if not, reset the agent and settings
 */
const useResetAgentForGuestUsers = () => {
  const [user, resetSettings] = store((state) => [
    state.user,
    state.resetSettings,
  ])
  const [agentId, isLoadingUser] = sessionStore((state) => [
    state.agent.id,
    state.UIElements.isLoadingUser,
  ])
  const setAgentId = useSetAgentId()

  const { data: agentResponse, isFetching } = useGetAgent({
    agentId: !user.id && agentId ? agentId : '',
    queryOptions: { refetchInterval: FIVE_MINUTES_IN_MS },
  })

  const { data: authSession } = useGetAuthSessionQuery()
  const cognitoUid = authSession?.cognitoUid

  useEffect(() => {
    if (
      !isFetching &&
      !user.id &&
      !cognitoUid &&
      !isLoadingUser &&
      agentId &&
      agentResponse?.data?.chatStatus !== EChatStatus.active
    ) {
      resetSettings()
      setAgentId(undefined)
    }
  }, [
    isFetching,
    agentId,
    user.id,
    cognitoUid,
    agentResponse?.data?.chatStatus,
    resetSettings,
    setAgentId,
    isLoadingUser,
  ])
}

export default useResetAgentForGuestUsers
